import { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Alert, Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, Row } from 'reactstrap';
import { Spinner } from 'src/components/Common/Spinner';
import { IGroup, ISetting, ISettingType } from 'src/services/types';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { createSetting, updateSetting } from 'src/services/settings-service';
import { createGroup, updateGroup } from 'src/services/group-service';

interface IProps {
    show: boolean;
    onClose: () => void;
    item: IGroup | null;
    onRefresh: () => void;
} 
export const CreateUpdateGroupModal = ({ show, onClose, item, onRefresh }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const formik = useFormik({
        enableReinitialize: true,

        initialValues: {
            name: item?.name || '',
            description: item?.description || '',
            color: item?.color || '',
            active: item?.active ?? true,
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required("Please enter name"),
            description: Yup.string().optional(),
            color: Yup.string().required("Please selected color"),
            active: Yup.boolean().optional(),
        }),
        onSubmit: (values) => {
            if(item) {
                onEdit(values);
            } else {
                onCreate(values);
            }
        }
    });

    const onCreate = async (values: Partial<IGroup>) => {
        setLoading(true);
        setErrorMessage('');
        const res = await createGroup(values)
        setLoading(false);
        if (res.result === 'ok') {
            toast('Setting created successfully', { type: 'success'});
            onRefresh();
            onClose();
        } else {
            setErrorMessage(res.message);
            console.log('error:', res.message);
        }
    }

    const onEdit = async (values: Partial<IGroup>) => {
        setLoading(true);
        setErrorMessage('');
        const res = await updateGroup(item?.id!, values)
        setLoading(false);
        if (res.result === 'ok') {
            toast('Group updated successfully', { type: 'success'});
            onRefresh();
            onClose();
        } else {
            setErrorMessage(res.message);
            console.log('error:', res.message);
        }
    }

    useEffect(() => {
        if(show) {
            formik.resetForm();
        }
    }, [show]);

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        className=''
    >
        {
            <div style={{position: 'relative', backgroundColor: loading ? '#D8C8B8' : '#fff' }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                        {item ? 'Edit Group' : 'Create Group'}
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                        aria-label="Close"
                    ></button>
                </div>
                <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            formik.handleSubmit();
                            return false;
                        }}
                >
                    <div className="modal-body">
                        <Row>
                            {/* {
                                !item ? (
                                    <>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="settingTypeId">Name</Label>
                                                <Input
                                                    name="name"
                                                    placeholder="Name"
                                                    type="text"
                                                    className="form-control"
                                                    id="text"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.name || ""}
                                                    invalid={
                                                        formik.touched.name && formik.errors.name ? true : false
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="settingTypeId">Description</Label>
                                                <Input
                                                    name="description"
                                                    placeholder="Description"
                                                    type="text"
                                                    className="form-control"
                                                    id="text"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.description || ""}
                                                    invalid={
                                                        formik.touched.description && formik.errors.description ? true : false
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                    </>
                                ) : null
                            } */}
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="name">Name</Label>
                                    <Input
                                        name="name"
                                        placeholder="Name"
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.name || ""}
                                        invalid={
                                            formik.touched.name && formik.errors.name ? true : false
                                        }
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="description">Description</Label>
                                    <Input
                                        name="description"
                                        placeholder="Description"
                                        type="text"
                                        className="form-control"
                                        id="description"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.description || ""}
                                        invalid={
                                            formik.touched.description && formik.errors.description ? true : false
                                        }
                                    />
                                    {formik.touched.description && formik.errors.description ? (
                                        <FormFeedback type="invalid">{formik.errors.description}</FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="color">Color</Label>
                                    <Input
                                        name="color"
                                        type="color"
                                        className="form-control"
                                        id="color"
                                        style={{ width: '150px' }}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.color || ""}
                                        invalid={
                                            formik.touched.color && formik.errors.color ? true : false
                                        }
                                    />
                                    {formik.touched.color && formik.errors.color ? (
                                        <FormFeedback type="invalid">{formik.errors.color}</FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup switch style={{ paddingLeft: '0px' }}>
                                    <div><Label htmlFor="active">Active</Label></div>
                                    <Input
                                        type="switch"
                                        checked={formik.values.active}
                                        onChange={() => formik.setFieldValue('active', !formik.values.active)}
                                        id="active"
                                        name="active"
                                        style={{ marginLeft: '0px' }}
                                        className="pl-3"
                                        onBlur={formik.handleBlur}
                                        // value={formik.values.active ? 'true' : 'false'}
                                        invalid={
                                            formik.touched.active && formik.errors.active ? true : false
                                        }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Alert color="danger" isOpen={errorMessage !== ''} toggle={() => setErrorMessage('')}>
                                {errorMessage}
                            </Alert>
                        </Row>

                        <div>
                            <Alert color="danger" isOpen={!!errorMessage} toggle={()=>setErrorMessage('')} >
                                {errorMessage}
                            </Alert> 
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                        <Button color="primary" type="submit">
                                {item ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Form>
                {
                    loading ? 
                    <div 
                        className='d-flex justify-content-center align-items-center rounded my-2 mx-2' 
                        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(253, 252, 255, 0.75)'}}
                    >
                         <div className="spinner-border text-primary" role="status">
                        </div>
                        <span className="text-primary fs-5 mx-2">
                            {item ? 'Updating group...' : 'Creating group...'}
                        </span>
                    </div>
                    : null
                }
            </div>   
        }
    </Modal>
  )
}
